function createOrderHtml(order, email) {
  return `
    <div class="customer-order__container">
      <div class="flex justify-between sm:align-center flex-col sm:flex-row">
        <div class="grid gap-2 font-san-serif">
          <h5 class="bold customer-order__order-number">#${order.orderNumber || order.id}</h5>
          <p>${order.total}</p>
          <p>${order.createdAt}</p>
          <p>${order.financialStatus}</p>
        </div>
        <div>
          <div class="flex gap-2">
            ${order.images
      .map(
        (image) => `
                  <div class="account-order__images w-24 h-24 flex-shrink-0 border border-gray-200">
                    <img src="${image}" alt="Order product image" class="w-full h-full object-cover" />
                  </div>
                `
      )
      .join("")}
          </div>
        </div>
      </div>
      ${order.orderUrl ? `
        <div class="flex flex-col md:flex-row gap-4 latest-order__btn-container">
          <a class="button" href="${order.orderUrl}">View order</a>
          <a class="button order-details__trigger button--outline button__max-width" href="https://portal.refundid.com/stores/${isNZ() ? 'scotch-and-soda-nz' : 'scotch-and-soda-au'}?email=${email}&order_number=${order.orderNumber}">Return items</a>
        </div>
      ` : ""}
    </div>
  `;
}

// Main function that obtains customer account orders from liquid and obtains dotApparel orders (retail orders)
window.allOrders = async function allOrders(customerEmail, customerSignature, orders) {
  let email = customerEmail;
  let signature = customerSignature;

  try {
    const orderData = [];

    orders.forEach((order, index) => {
      if (!order || typeof order !== "object") {
        console.error(`Invalid order at index ${index}:`, order);
        return;
      }

      const {
        order_number: orderNumber,
        created_at: createdAt,
        total_price: amount,
        financial_status_label: financialStatusLabel,
        order_url: orderUrl,
        line_items: lineItems,
      } = order;

      let lineItemImages = lineItems.map(item => item.image);

      orderData.push({
        orderNumber,
        financialStatus: financialStatusLabel,
        orderUrl,
        createdAt,
        timestamp: createdAt,
        total: amount,
        images: lineItemImages.length > 0 ? lineItemImages : [],
      });
    });

    const retailTransactionsData = await dotApparel("api-retailTransactions", {
      method: "POST",
      body: {
        email,
        signature,
      },
    });

    const retailTransactions = retailTransactionsData.retailTransactions
      .filter((order) =>
        !order.transactionNumber?.startsWith("AU-") &&
        !order.transactionNumber?.startsWith("NZ-"))
      .map((order) => {
        const { transactionNumber, storeName, saleDate, items } = order;

        const formattedSaleDate = formatDate(saleDate);

        const total = items.reduce((acc, { value }) => acc + parseFloat(value), 0);
        const status = total < 0 ? "Refunded" : "Paid";
        return {
          id: transactionNumber,
          orderNumber: transactionNumber,
          createdAt: formattedSaleDate,
          timestamp: saleDate,
          financialStatus: `${status} - ${storeName}`,
          total: `$${total.toFixed(2)}`,
          images: [],
        };
      });

    const allOrders = [...orderData, ...retailTransactions].sort((a, b) => {
      const timeA = Date.parse(a.timestamp);
      const timeB = Date.parse(b.timestamp);
      return timeB - timeA;
    });

    // Used on account dashboard
    const dashboardOrdersContainer = document.querySelector(".dashboard-customer-order__container");

    // Used on account orders page
    const accountOrdersContainer = document.querySelector(".account-orders__container");

    if (dashboardOrdersContainer && accountOrdersContainer) {
      if (allOrders.length === 0) {
        dashboardOrdersContainer.innerHTML = `
          <div class="flex flex-col gap-10">
            <p class="font-san-serif">You have no orders</p>
            <a class="button button--outline order-details__trigger button__max-width" href="${window?.location?.href}?page=order-details">View all orders</a>
          </div>
        `;

        accountOrdersContainer.innerHTML = `<h5 class="account-orders__no-orders bold uppercase button__max-width ">You have no orders</h5>`;
      } else {
        dashboardOrdersContainer.insertAdjacentHTML("beforeend", createOrderHtml(allOrders[0], email));

        allOrders.forEach((order) => {
          accountOrdersContainer.insertAdjacentHTML("beforeend", createOrderHtml(order, email));
        });
      }
    }

    return {
      error: false,
      message: null,
      data: allOrders,
    };
  } catch (error) {
    console.error("[ERROR] Orders:", error.message);
    return {
      error: true,
      message: error.message,
      data: null,
    };
  }
};
